module.exports = __webpack_public_path__ + "img/14.36a68ea3.jpg";